import useModalClickOutside from "utils/useModalClickOutside";
import { useTranslation } from "next-i18next";
import BottomModal from "components/common/Modal/BottomModal";
import Image from "next/image";
import moment from "moment-timezone";
import { TYPO } from "styles/Typo";
import { useHandleImageErrorVer2 } from "utils/useHandleImageError";
import { useRouter } from "next/router";
import Icon, { ICONS } from "components/common/Icons";
import { ListTemp } from "./Repoprt";

function InterestReportModal({ setModalOpen, isModalOpen, data }: any) {
  const modalRef = useModalClickOutside(setModalOpen);

  return (
    <BottomModal
      isOpen={isModalOpen}
      modalRef={modalRef}
      containerClass="max-h-[80%] overflow-y-auto scroll !p-0"
    >
      <div className="w-full">
        <div className="py-2 pr-2 flex justify-end bg-background sticky top-0 z-[1] ">
          <div
            className="p-[6px] cursor-pointer"
            onClick={() => setModalOpen(false)}
          >
            <Icon name={ICONS.CLOSE} fill="var(--gray90)" />
          </div>
        </div>
        <div className="p-6 flex flex-col gap-[40px]">
          {data?.map((item: any, index: number) => (
            <ListTemp key={index} agenda={item} animation={""} env="bs" />
          ))}
        </div>
      </div>
    </BottomModal>
  );
}

export default InterestReportModal;
